import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Input, and the TextField composite for the common case.
 *
 * `numeric` is not decoration: money, time and counts are read down a column, so they are set in
 * the data face with tabular figures (BRAND.md §5). It also asks for the numeric keypad on a phone
 * and on the kiosk's on-screen keyboard.
 */
import { forwardRef } from 'react';
import { cx } from '../lib/cx.js';
import { Field, controlDomProps } from './field.js';
export const Input = forwardRef(function Input({ numeric = false, className, type = 'text', inputMode, ...rest }, ref) {
    return (_jsx("input", { ...rest, ref: ref, type: type, inputMode: inputMode ?? (numeric ? 'decimal' : undefined), className: cx('clav-input', numeric && 'clav-input--numeric', className) }));
});
/** A labelled text input, wired for description and error, in one element. */
export function TextField({ label, description, error, required, showOptional, className, ...input }) {
    return (_jsx(Field, { label: label, description: description, error: error, required: required, showOptional: showOptional, className: className, children: (control) => _jsx(Input, { ...input, ...controlDomProps(control) }) }));
}
//# sourceMappingURL=input.js.map